import React, { useState } from "react";
import ContactItem from "./ContactItem";
import phone from "./phone.svg";
import email1 from "./emailme.svg";
import location from "./location.svg";
import { db } from "./Firebase.jsx";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    db.collection("contacts")
      .add({
        email: email,
        message: message,
      })
      .then(() => {
        alert("Thanks! Your message has been sent👍");
      })
      .catch((error) => {
        alert(error.message);
      });
    setEmail("");
    setMessage("");
  };
  return (
    <div>
      <div className="ContactPage" id="contact">
        <div className="map-sect">
          <div className="contact">
            <div className="right">
              <h2>Contact me</h2>
              <form onSubmit={handleSubmit}>
                <input required
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <textarea required
                  placeholder="Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <button type="submit">Send</button>
                
              </form>
            </div>
          </div>
        </div>
        <div className="contact-sect">
          <ContactItem
            icon={phone}
            text1={"+91 8448612719"}
            text2={"+91 8941934119"}
            title={"Phone"}
          />
          <ContactItem
            icon={email1}
            text1={"Sandeepbishtit@gmail.com"}
            text2={"Sandeepbisht53@gmail.com"}
            title={"Email"}
          />
          <ContactItem
            icon={location}
            text1={"Z-Block Sector-12,Noida,UP"}
            text2={"India"}
            title={"Address"}
          />
        </div>
      </div>
    </div>
  );
}
